import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core'; 
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocationService } from '../../services/location-service';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { KeycloakAuthService } from 'src/app/auth/keycloak-auth.service';
import { AuthActions } from 'src/app/common/store/actions/auth.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAuthLoggedIn, selectAuthUserId, selectTotalFavorites, selectDealerFname, selectSelectedCountryCodes } from 'src/app/common/store/state/app.state';
import { AppConstants } from '../../constants/app-constants';
import { GeneralBasicData } from '../../constants/general-basic-data';
import { Country } from '../../models/country.model';


@Component({
    selector: 'app-page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageContentComponent implements OnInit {

  loggedIn$: Observable<boolean>; 
  loggedIn: boolean = false;

  loggedInUserId$: Observable<string | null>;
  loggedInUserId: string = "";

  totalFavorites$: Observable<number>;
  fname$: Observable<string>;

  selectedCountryCodes$: Observable<string[]>;
  //selectedCountry$: Observable<Country>;

  //selectedCountries: Country[] = [];
  selectedCountryCodes: string[] = [];

  isHandset: boolean = false;
  MIN_WIDTH: number = 1000;

  CarBusinessLine = CarBusinessLine;

  isMultiCountry: boolean = true;

  //countryCode: string = AppConstants.COUNTRY_CODE_DEFAULT;
  countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;

  currentUserFname$: Observable<string>;

  constructor(
    private store: Store,
    private router: Router,
    private authService: KeycloakAuthService
    ) {
      
      //this.login()

      this.loggedIn$ = store.select(selectAuthLoggedIn);
      this.loggedInUserId$ = this.store.select(selectAuthUserId);

      this.totalFavorites$ = store.select(selectTotalFavorites);
      this.fname$ = store.select(selectDealerFname);

      this.selectedCountryCodes$ = store.select(selectSelectedCountryCodes);
      //this.selectedCountry$ = store.select(selectSelectedCountry);

      //this.loggedInUserId$ = store.select(selectLoggedInUserDataId);
      this.currentUserFname$ = this.store.select(selectDealerFname);

    }

  ngOnInit(): void {
    this.isHandset = (window.innerWidth < this.MIN_WIDTH);

    this.selectedCountryCodes$.subscribe(
      (countryCodes) => {

        //this.selectedCountryIds = countryCodes.length !== 0 ? countryCodes : ["All"];
        //this.selectedCountries = GeneralBasicData.getCountriesByCodes(countryCodes)!;
        this.selectedCountryCodes = countryCodes;
        //this.store.dispatch(SearchActions.fetchRecentCarBriefsSubmit({countryCodes: countryCodes}));
      }
    );
    /**/
    this.loggedIn$ = this.store.select(selectAuthLoggedIn); 
    this.loggedInUserId$ = this.store.select(selectAuthUserId);
    //this.loggedInUserId$ = this.store.select(selectLoggedInUserDataId);
    this.currentUserFname$ = this.store.select(selectDealerFname);

    this.loggedIn$.subscribe(
      (res) => {
        this.loggedIn = res!
      }
    );

    this.loggedInUserId$.subscribe(
      (res) => {
        this.loggedInUserId = res!
      }
    );

  }
 
  logout(): void {

    this.store.dispatch(AuthActions.logoutSubmit());
    this.authService.logout(window.location);
    //this.router.navigate(['/']);
  }

  login(): void {
    this.authService.login(window.location);
    //this.router.navigate(['/customer']); 
  }

  postNewCar(): void {
    this.router.navigate(['/owner/post-new-car']);
  }
  

  getLoggedInUsername(): string {

    //this.store.dispatch(AuthActions.logoutSubmit());
    //return this.authService.getUserName()
    //this.router.navigate(['/']);

    return this.loggedInUserId
  }

  getLoggedInChar(): string {

    //return this.authService.getLoggedInChar();

    return this.loggedInUserId
  }

  getLoggedInUserDetails(): any {

    //this.store.dispatch(AuthActions.logoutSubmit());
    //console.log(JSON.stringify(this.authService.getLoggedUser()))

    //let a = this.authService.getLoggedUser()
    //return "("+a.given_name+" - "+a.email+")";

    //return "("+a?.given_name+")";
    //this.router.navigate(['/']);

    return this.loggedInUserId
  }

  isLoggedInOld(): boolean {

    let old: boolean = this.loggedIn

    //this.loggedIn = this.authService.isLoggedIn()

    if(this.loggedIn && (!old || this.loggedInUserId === '')){
      //this.store.dispatch(DealerActions.fetchMyDealerProfileSubmit());
    }

    return this.loggedIn
  }

  onResize(event: any) {
 
    this.isHandset = (window.innerWidth < this.MIN_WIDTH);  
  }

  getCountrye(): Country | null {
    let code: string =  LocationService.getCurrentCountryCode();
    
    return GeneralBasicData.getCountryByCode(code)!;
  }

  getCountryName(code: string): string {

    return GeneralBasicData.getCountryByCode(code)!.name;
  }

  updateCountries(eventVal: any){

    console.log(eventVal.length)

    //this.selectedCountryCodes = Array.isArray(eventVal) ? eventVal : [eventVal];

    console.log(this.selectedCountryCodes)
    this.store.dispatch(SearchActions.changeSelectedCountriesSubmit({ countryCodes: Array.isArray(eventVal) ? eventVal : [eventVal] }))
  }

  switchBusinessLine(crt: CarBusinessLine){
    this.store.dispatch(SearchActions.switchBusinessLine({businessLine: crt}))
  }

  goToAccount(){
    this.router.navigate(
      ['/account']
    );
  }
}
